var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M110.2 37l-19-17.4H34c-2 0-3.7 1.6-3.7 3.7V118c0 2 1.6 3.7 3.7 3.7h72.6c2 0 3.7-1.6 3.7-3.7v-5.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M91.3 19.7V37h18.9M109.3 103.1H45.9c-2.8 0-5.1-2.3-5.1-5.1V51.4c0-2.8 2.3-5.1 5.1-5.1h63.4c2.8 0 5.1 2.3 5.1 5.1V98c0 2.8-2.3 5.1-5.1 5.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    strokeDasharray: "6,6",
    d: "M86 62v-3H62v24h10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M72 66h24v24H72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.6724a1772d8d8bad6a151e6efbed2a03.svg";
export { ForwardRef as ReactComponent };